import script from "./ticket-promo-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./ticket-promo-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__